export const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return true;
  } else if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === 'object') {
    return Object.keys(value as Record<string, unknown>).length === 0;
  } else {
    return false; // If value is not an array or object, it's not considered "empty"
  }
};
